import { useLockScroll } from 'hooks/use-lock-scroll'
import { ReactNode, useEffect } from 'react'
import { Container, Overlay } from './styles'

interface IProps {
  isOpen: boolean
  onClose(): void

  children: ReactNode
}

const Modal = (props: IProps) => {
  const { lock, unlock } = useLockScroll()

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation()

  useEffect(() => {
    if (props.isOpen) {
      lock()
    } else {
      unlock()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen])

  if (!props.isOpen) return null

  return (
    <Overlay onClick={props.onClose}>
      <Container onClick={stopPropagation}>{props.children}</Container>
    </Overlay>
  )
}

export default Modal
